import { Badge } from "@/components/ui/badge";
import formatNumber from "@/utils/formatNumber";
import Image from "next/legacy/image";
import Link from "next/link";
import React, { useState, useContext } from "react";
import { fitIn } from "@/utils/imageHandler";
import DummyLogo from "@/assets/images/lucidity-placeholder.png";
import { DotsThreeVertical, Heart, Plus } from "@phosphor-icons/react";
import acquired_badge from "@/assets/images/acquired_badge.svg";
import WishlistAddNew from "../WishlistAddNew";
import { useRouter } from "next/router";
import unicorn from "@/assets/images/unicorn.svg";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "../ui/button";
import {
  createWishlist,
  createWishlistCategory,
  deleteWishlist,
} from "@/services/api/Wishlist";
import { useAtom } from "jotai";
import { loginPopup } from "@/Atoms";
import AppContext from "@/AppContext";
import InActiveIcon from "@/assets/images/inactive.png";

const StartupCard = ({
  user,
  startup,
  newTab = false
  // getWishlistCategories,
  // wishlistCategories,
  // setWishlistCategories,
  // getUserWishlist,
  // userWishlistIds,
  // userWishlist,
}) => {
  const router = useRouter();
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [openWishlistAction, setOpenWishlistAction] = useState(false);
  const [openLoginPopup, setOpenLoginPopup] = useAtom(loginPopup);

  const {
    userVCWishlistIds,
    onRemoveVCWishlist,
    userStartupWishlistIds,
    getWishlistCategories,
    wishlistCategories,
    addWishlistCategory,
    state,
    removeWishlist,
    userWishlist,
    userWishlistIds,
    getUserWishlist,
  } = useContext(AppContext);

  const { planSubscription } = state;

  const hasSubscription =
    planSubscription && planSubscription.has_active_subscription;

  // Function to handle My Wishlist click without propagating
  const handleMyWishlistClick = (event, cat_id) => {
    event.stopPropagation();
    setWishlist(cat_id);
    // Add navigation or any other logic for My Wishlist here
  };

  const setWishlist = async (cat_id) => {
    const res = await createWishlist({
      category_id: cat_id,
      content_id: startup.id,
      type: 1,
    });
    getUserWishlist();
  };

  const onRemoveWishlist = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const found = userWishlist.find((v) => v.content_id == startup.id);
    if (found) {
      removeWishlist(found.id);
    }
  };

  const handleChange = (e) => {
    if (!user) {
      return setOpenLoginPopup(true);
    }
    getWishlistCategories();
    setOpenWishlistAction(e);
  };

  // const addWishlistCategory = async (payload) => {
  //   try {
  //     const res = await createWishlistCategory(payload);
  //     setWishlist(res.data.id);
  //     setWishlistCategories(null);
  //     getWishlistCategories();
  //     setIsAddDialogOpen(false);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  return (
    <>
      <div
        className='relative h-full block bg-gradient-to-tr from-yellow-1 to-red-1 rounded-2xl p-[1.5px]'
        key={`startup-${startup.uuid || startup.id}`}
      >
        <div
          onClick={() => {
            if (newTab) {
              window.open(`/startups/${startup.slug}-${startup.id}`, '_blank');
            } else {
              router.push(`/startups/${startup.slug}-${startup.id}`);
            }
          }}
          className={`flex flex-col items-center justify-between h-full relative text-xs bg-background rounded-2xl text-center cursor-pointer`}
        >
          <span className='absolute inset-0 w-full h-full overflow-hidden rounded-2xl opacity-90'>
            <span className='absolute top-0 right-0 rounded-full size-20 bg-orange-1 blur-[80px]'></span>
          </span>

          {userWishlistIds && (
            <div className='absolute z-10 flex items-center text-white gap-x-1 right-1.5 top-2'>
              {userWishlistIds.includes(startup.id) ? (
                <button type='button' onClick={onRemoveWishlist}>
                  <Heart weight='fill' color='red' className='text-2xl' />
                </button>
              ) : (
                <DropdownMenu
                  open={openWishlistAction}
                  onOpenChange={handleChange}
                >
                  <DropdownMenuTrigger asChild>
                    <button type='button' onClick={(e) => {
                      e.stopPropagation();
                      handleChange(e);
                    }}>
                      <Heart weight='bold' className='text-2xl' />
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className='w-[200px] max-h-[300px] overflow-y-auto'>
                    <DropdownMenuLabel className='text-xs font-medium text-white/40'>
                      Add to Watchlist
                    </DropdownMenuLabel>
                    <DropdownMenuItem
                      onClick={(event) => {
                        event.stopPropagation(); // Prevent click event from bubbling up
                        setIsAddDialogOpen(true); // Open the add dialog
                        setOpenWishlistAction(false);
                      }}
                    >
                      <Plus weight='bold' className='mr-2' />
                      <span>Create New Watchlist</span>
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem
                      onClick={(e) => handleMyWishlistClick(e, null)}
                    >
                      My Watchlist
                    </DropdownMenuItem>
                    {hasSubscription &&
                      wishlistCategories?.map((cat) => (
                        <DropdownMenuItem
                          key={cat.id}
                          onClick={(e) => handleMyWishlistClick(e, cat.id)}
                        >
                          {cat.name}
                        </DropdownMenuItem>
                      ))}
                  </DropdownMenuContent>
                </DropdownMenu>
              )}
            </div>
          )}

          <div className='relative flex-1 w-full'>
            <span className='inline-block p-0.5 bg-gradient-to-tr from-yellow-1 to-red-1 -translate-y-1/2 rounded-full'>
              <div className='relative flex-shrink-0 overflow-hidden rounded-full w-14 h-14 aspect-square'>
                <Image
                  src={startup.logo_url || DummyLogo}
                  alt={startup.name || "Startup Logo"}
                  layout='fill'
                  sizes='(min-width: 768px) 400px, 200px'
                  objectFit={"cover"}
                />
              </div>
            </span>
            {startup.is_inactive === 1 && (
              <div className='absolute top-2 left-2 z-10'>
                <span className='inline-flex items-center justify-center px-2 py-1 text-[8px] tracking-wide uppercase font-medium leading-none rounded-full bg-gradient-to-tr from-red-700 to-red-500'>
                  Inactive
                </span>
              </div>
            )}

            <div className='p-4 pt-1.5 -mt-7'>
              <p className='text-lg font-semibold leading-tight tracking-tight truncate'>
                {startup.name}
              </p>
              {startup.formerly_named && (
                <p className='text-[9px] truncate'>
                  <span className='text-white/40'>Formerly </span>
                  <span className='text-white'>{startup.formerly_named}</span>
                </p>
              )}
              <p className='mt-0.5 truncate opacity-40'>
                {startup.city?.name}
                {startup.city?.name &&
                  startup.country?.country_name &&
                  ", "}{" "}
                {startup.country?.country_name}
              </p>
              <div className='mt-2 lg:mt-3'>
                <p className='text-3xl font-bold leading-none tracking-tight text-transparent bg-clip-text bg-gradient-to-tr from-yellow-400 to-red-600'>
                  {startup.total_funding_round_amount
                    ? `$${formatNumber(startup.total_funding_round_amount)}`
                    : "N/A"}
                </p>
                <p className='mt-1 opacity-40 text-[11px]'>Funds Raised</p>
              </div>
              <div className='flex flex-wrap items-start justify-center flex-grow gap-1 mt-3 lg:mt-4'>
                {startup.sectors?.length > 0 ? (
                  <>
                    {startup.sectors.slice(0, 3).map((sector) => (
                      <Badge
                        key={sector.id}
                        variant='outline'
                        className='border-white/10 font-medium text-[9px] lg:text-[10px] text-white/70 shadow-sm !h-auto py-0.5 px-2 bg-white/5'
                      >
                        {sector.name}
                      </Badge>
                    ))}
                    {startup.sectors.length > 3 && (
                      <Badge
                        variant='outline'
                        className='border-white/10 font-medium text-[10px] text-white/70 shadow-sm !h-auto py-0.5 px-2 bg-white/5'
                      >
                        +{startup.sectors.length - 3}
                      </Badge>
                    )}
                  </>
                ) : (
                  <Badge
                    variant='outline'
                    className='border-white/10 font-medium text-[10px] text-white/30 shadow-sm !h-auto py-0.5 px-2 bg-white/5'
                  >
                    No Sector Specified
                  </Badge>
                )}
              </div>
            </div>
          </div>

          {(startup.is_unicorn === 1 || !!startup.has_ipo_data || !!startup.has_acquisition_data) && (
            <div className='mb-3 flex justify-center shrink-0 [&>*:not(:first-child)]:-ml-1.5'>
              {startup.is_unicorn === 1 && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span className='inline-flex items-center justify-center border-2 rounded-full w-7 h-7 border-background bg-gradient-to-tr from-purple-500 to-teal-500'>
                        <div className='relative aspect-[333/294] h-3.5'>
                          <Image src={unicorn} layout='fill' alt='Unicorn' />
                        </div>
                      </span>
                    </TooltipTrigger>
                    <TooltipContent className='max-w-md text-black bg-white border-none'>
                      <p className='text-xs'>
                        Unicorns are considered any privately owned startup that
                        has successfully achieved a valuation of US $1 billion
                        or more at any time in its history. Companies which
                        achieved this status post-IPO are not considered
                        unicorns.
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}

              {!!startup.has_ipo_data && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span className='relative inline-flex items-center justify-center -ml-1.5 border-2 rounded-full w-7 h-7 border-background bg-gradient-to-tr from-red-500 to-yellow-500'>
                        <div className='relative text-[10px] font-bold tracking-tight'>
                          IPO
                        </div>
                      </span>
                    </TooltipTrigger>
                    <TooltipContent className='max-w-md text-black bg-white border-none'>
                      <p className='text-xs'>
                        Company offers its shares to the public for the first
                        time, thereby becoming a publicly traded company.
                        Companies typically go public to raise capital to fund
                        growth, pay off debt, or allow early investors and
                        founders to realize some of their gains by selling their
                        shares in the public market
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}

              {!!startup.has_acquisition_data && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className='relative -ml-1 border-2 rounded-full aspect-square h-7 border-background'>
                        <Image
                          src={acquired_badge}
                          layout='fill'
                          alt='Acquired'
                        />
                      </div>
                    </TooltipTrigger>
                    <TooltipContent className='max-w-md text-black bg-white border-none'>
                      <p className='text-xs'>
                        This startup has been acquired by another company or
                        investor, marking a significant milestone in its
                        journey.
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
            </div>
          )}
        </div>
      </div>
      {/* <Link
        href={`/startups/${startup.slug}-${startup.id}`}
        className='cursor-pointer block relative px-4 pb-4 mt-7 lg:mt-[36px] rounded-lg bg-white/5 group hover:bg-white/10 transition'
      >
        {!!startup.is_inactive && (
          <div className='absolute top-1.5 left-[88px]'>
            <span className='inline-flex items-center justify-center px-2 py-1 text-[8px] tracking-wide uppercase font-medium leading-none rounded-full bg-gradient-to-tr from-red-700 to-red-500'>
              Inactive
            </span>
          </div>
        )}
        {userWishlistIds && (
          <div className='absolute flex items-center text-white gap-x-1 right-1.5 top-2'>
            {userWishlistIds.includes(startup.id) ? (
              <button type='button' onClick={onRemoveWishlist}>
                <Heart weight='fill' color='red' className='text-2xl' />
              </button>
            ) : (
              <DropdownMenu
                open={openWishlistAction}
                onOpenChange={handleChange}
              >
                <DropdownMenuTrigger asChild>
                  <button type='button'>
                    <Heart weight='bold' className='text-2xl' />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className='w-[200px] max-h-[300px] overflow-y-auto'>
                  <DropdownMenuLabel className='text-xs font-medium text-white/40'>
                    Add to Watchlist
                  </DropdownMenuLabel>
                  <DropdownMenuItem
                    onClick={(event) => {
                      event.stopPropagation(); // Prevent click event from bubbling up
                      setIsAddDialogOpen(true); // Open the add dialog
                      setOpenWishlistAction(false);
                    }}
                  >
                    <Plus weight='bold' className='mr-2' />
                    <span>Create New Watchlist</span>
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem
                    onClick={(e) => handleMyWishlistClick(e, null)}
                  >
                    My Watchlist
                  </DropdownMenuItem>
                  {hasSubscription &&
                    wishlistCategories?.map((cat) => (
                      <DropdownMenuItem
                        key={cat.id}
                        onClick={(e) => handleMyWishlistClick(e, cat.id)}
                      >
                        {cat.name}
                      </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
              </DropdownMenu>
            )}
          </div>
        )}
        <div className='flex flex-col justify-between h-full'>
          <div>
            <div className='relative w-14 lg:w-[72px] mb-1 -mt-7 lg:-mt-[36px] -ml-2 overflow-hidden border-4 lg:border-8 rounded-full aspect-square border-background'>
              <Image
                src={fitIn(startup.logo_url, 400)}
                alt={startup.name}
                layout={"fill"}
                objectFit={"cover"}
              />
            </div>
            <div className='flex-1'>
              <div className='flex items-center'>
                <p className='mb-1.5 text-sm font-semibold lg:leading-tight lg:text-lg'>
                  {startup.name}
                </p>
              </div>
              {startup.city && startup.country && (
                <p className='mb-2 text-xs opacity-50'>
                  {startup.city?.name}, {startup.country?.country_name}
                </p>
              )}

              {startup.sectors.slice(0, 4).map((sector, index) => (
                <Badge
                  variant='outline'
                  key={index}
                  className='hidden lg:inline-flex border-dashed text-[10px] border-white/10 px-2 mr-0.5 font-normal text-white/70'
                >
                  {sector.name}
                </Badge>
              ))}

              {startup.sectors.length > 4 && (
                <Badge
                  variant='outline'
                  key='more'
                  className='hidden lg:inline-flex border-dashed text-[10px] border-white/10 px-2 mr-0.5 font-normal text-white/70'
                >
                  +{startup.sectors.length - 4}
                </Badge>
              )}
            </div>
          </div>
          <div className='flex items-end justify-between mt-2 lg:mt-3.5'>
            <p className='flex flex-col'>
              <span className='text-[10px] lg:text-[11px] opacity-40 mb-0.5'>
                Funds Raised
              </span>
              <span
                className={`text-transparent bg-clip-text bg-gradient-to-tr inline-block mr-1.5 ${
                  Number(startup.total_round_amount)
                    ? "lg:text-2xl tracking-tight -mb-1 text-lg from-yellow-1 to-red-1"
                    : "lg:text-sm text-xs from-white/50 to-white/80"
                } font-bold`}
              >
                {Number(startup.total_round_amount)
                  ? `$${formatNumber(startup.total_round_amount)}`
                  : "Undisclosed"}
              </span>
            </p>
            <div className='flex -mr-0.5'>
              {!!startup.is_unicorn && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span className='inline-flex items-center justify-center border-2 rounded-full w-7 h-7 border-background bg-gradient-to-tr from-purple-500 to-teal-500'>
                        <div className='relative aspect-[333/294] h-3.5'>
                          <Image src={unicorn} layout='fill' alt='' />
                        </div>
                      </span>
                    </TooltipTrigger>
                    <TooltipContent className='max-w-md text-black bg-white border-none'>
                      <p className='text-xs'>
                        Unicorns are considered any privately owned startup that
                        has successfully achieved a valuation of US $1 billion
                        or more at any time in its history. Companies which
                        achieved this status post-IPO are not considered
                        unicorns.
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}

              {!!startup.has_ipo_data && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span className='relative inline-flex items-center justify-center -ml-1.5 border-2 rounded-full w-7 h-7 border-background bg-gradient-to-tr from-red-500 to-yellow-500'>
                        <div className='relative text-[10px] font-bold tracking-tight'>
                          IPO
                        </div>
                      </span>
                    </TooltipTrigger>
                    <TooltipContent className='max-w-md text-black bg-white border-none'>
                      <p className='text-xs'>
                        Company offers its shares to the public for the first
                        time, thereby becoming a publicly traded company.
                        Companies typically go public to raise capital to fund
                        growth, pay off debt, or allow early investors and
                        founders to realize some of their gains by selling their
                        shares in the public market
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}

              {!!startup.has_acquisition_data && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className='relative -ml-1 border-2 rounded-full aspect-square h-7 border-background'>
                        <Image src={acquired_badge} layout='fill' alt='' />
                      </div>
                    </TooltipTrigger>
                    <TooltipContent className='max-w-md text-black bg-white border-none'>
                      <p className='text-xs'>
                        This startup has been acquired by another company or
                        investor, marking a significant milestone in its
                        journey.
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
            </div>
          </div>
        </div>
      </Link> */}
      <WishlistAddNew
        addWishlistCategory={addWishlistCategory}
        isOpen={isAddDialogOpen}
        setIsOpen={setIsAddDialogOpen}
        wishlistCategories={wishlistCategories}
        hasSubscription={hasSubscription}
      />
    </>
  );
};

export default StartupCard;
